import script from "./departmentManage.vue?vue&type=script&setup=true&lang=js"
export * from "./departmentManage.vue?vue&type=script&setup=true&lang=js"

import "./departmentManage.vue?vue&type=style&index=0&id=a74b3948&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a74b3948"]])

export default __exports__